// src/store/useUnreadStore.js
import { create } from 'zustand';

const useUnreadStore = create((set) => ({
    unreadCount: 0,
    setUnreadCount: (count) => set({ unreadCount: count }),
}));

export default useUnreadStore;
